/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Rephrase_ExpandInputs */

const en_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rephrase - Expand`)
};

const fr_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformuler - Etendre`)
};

const de_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umformulieren – Erweitern`)
};

const it_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riformulare - Espandere`)
};

const ru_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перефразировать - Развернуть`)
};

const es_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformular - Expandir`)
};

const zh_cn2_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`改写 - 扩展`)
};

const ja_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言い換え - 展開`)
};

const hi_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुनर्कथन - विस्तार करें`)
};

const pt_pt2_event_ad_rephrase_expand = /** @type {(inputs: Event_Ad_Rephrase_ExpandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reformule - Expanda`)
};

/**
* | output |
* | --- |
* | "Rephrase - Expand" |
*
* @param {Event_Ad_Rephrase_ExpandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_rephrase_expand = /** @type {((inputs?: Event_Ad_Rephrase_ExpandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Rephrase_ExpandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_rephrase_expand(inputs)
	if (locale === "de") return de_event_ad_rephrase_expand(inputs)
	if (locale === "it") return it_event_ad_rephrase_expand(inputs)
	if (locale === "ru") return ru_event_ad_rephrase_expand(inputs)
	if (locale === "es") return es_event_ad_rephrase_expand(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_rephrase_expand(inputs)
	if (locale === "ja") return ja_event_ad_rephrase_expand(inputs)
	if (locale === "hi") return hi_event_ad_rephrase_expand(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_rephrase_expand(inputs)
	return en_event_ad_rephrase_expand(inputs)
});